// extracted by mini-css-extract-plugin
module.exports = {"container":"EditCategory_container__6jbac","menu":"EditCategory_menu__N9w1X","imageItem":"EditCategory_imageItem__3fLmx"};